
/*
 * ajout d'un block
 */
$(document).on('click', '[data-addblock]', function(e) {
	e.preventDefault();

	var $this = $(this);
	var block = $this.data('addblock');
	// si le block est vide ou n'existe pas on quitte
	if( block == '' || !$(block).get().length )
		return;

	var $container = $($this.data('container')).get().length ? $($this.data('container')) : $this.parent();

	var str = $(block).html();

	// iteration
	var iteration = $('[data-iteration]', $container).get().length;
	str = str.replace(/{{iteration}}/g, iteration);

	// add random string to ids
	var random_str = Math.floor((Math.random() * 100000000) + 1).toString();
	str = str.replace(/(id|for)="(.+?)"/g, '$1="$2' + random_str + '"');

	$container.append(str);

	$('[data-toggle="datepicker"]', $container).datepicker({
		language: 'fr-FR',
		autoHide: true,
		zIndex: 9999
	});

	_init_sortable();

	$(':last-child', $container).trigger('addblock:new');
});


/*
 * suppression d'un block
 */
$(document).on('click', '[data-remove]', function(e) {
	e.preventDefault();

	var $this = $(this);

	// si confirmation
	if( $this.is('[data-confirm]') ) {
		var text = $this.data('confirm') != '' ? $this.data('confirm') : __str('Are you sure?');
		if( !confirm(text) )
			return false;
	}

	var $block = $($this.parents('._toremove').get(0));
	var iteration = $block.is('[data-iteration]');
	var $parent = $block.parent();
	$block.remove();
	// on refait les itérations
	if( iteration ) {
		$('[data-iteration]', $parent).each(function(i, el) {
			var old = $(el).data('iteration');
			$(el).data('iteration', i);
			$(el).attr('data-iteration', i);
			$('[name*="[' + old + ']"]', el).each(function(j, input) {
				var name = $(input).attr('name');
				name = name.replace('[' + old + ']', '[' + i + ']');
				$(input).attr('name', name);
			});
		});
	}
});



/*
 * upload images
 */

import ss from 'simple-ajax-uploader';

function createImgUploader(el) {
	var multiple = $(el).is('[data-single]') ? false : true;
	var name_images = $(el).is('[data-name-images]') ? $(el).data('name-images') : 'images';
	var $target = $(el).is('[data-target]') ? $($(el).data('target')) : $(el).next();
	var imageuploader = new ss.SimpleUpload({
		button: $(el),
		url: $(el).data('url'),
		name: 'uploadfile',
		multiple: multiple,
		multipleSelect: multiple,
		hoverClass: 'hover',
		focusClass: 'hover',
		progressUrl: $(el).data('progress'),
		responseType: 'json',
		accept: 'image/*',
		allowedExtensions: ['jpg', 'jpeg', 'png', 'gif'],
		onChange: function( filename, extension, uploadBtn, fileSize, file ) {
			$('.alert', $target).remove();
		},
		onSubmit: function(filename, extension, uploadBtn, fileSize) {
			$('.alert', $target).remove();
			$target.prepend('<div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>');
			var wrapper = $('.progress', $target).get(0);
			this.setProgressContainer(wrapper);
			this.setProgressBar( $('.progress-bar', wrapper).get(0) );
			this.setPctBox( $('.progress-bar', wrapper).get(0) );
		},
		onExtError: function( filename, extension ) {
			$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Type de fichier non autorisé (jpg, jpeg, png, gif)') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
		},
		onSizeError: function( filename, fileSize ) {
			$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Le fichier est trop volumineux') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
		},
		onComplete: function(filename, response) {
			if(!response) {
				$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
			}
			else {
				if(response.success) {
					var value = {
						type: 'image',
						original_filename: filename,
						filename: response.file,
						path: response.path,
						thumbnail: response.path + response.file,
						legende: {}
					};
					var gallery = $(el).is('[data-gallery]') ? ' data-gallery="' + $(el).data('gallery') + '"' : '';
					var html = '<div class="_toParse image_thumb _toremove" data-type="image"' + gallery + '><textarea class="_toParse_value" name="' + name_images + '">' + JSON.stringify(value) + '</textarea></div>';
					if( multiple )
						$target.append(html);
					else
						$target.html(html);
					$('._toParse', $target).each(function(i, el) {
						parseBlock(el);
					});
				}
				else {
					$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + response.file + '<br>' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
					return false;
				}
			}
		}
	});
}


$('._upload_image').each(function(i, el) {
	createImgUploader(el);
});
$(document).on('lightbox:show', function(e) {
	$('._upload_image', e.target).each(function(i, el) {
		createImgUploader(el);
	});
});


/*
 * upload videos
 */
function createVideoUploader(el) {
	var multiple = $(el).is('[data-single]') ? false : true;
	var name_images = $(el).is('[data-name-images]') ? $(el).data('name-images') : 'videos';
	var $target = $(el).is('[data-target]') ? $($(el).data('target')) : $(el).next();
	var imageuploader = new ss.SimpleUpload({
		button: $(el),
		url: $(el).data('url'),
		name: 'uploadfile',
		multiple: multiple,
		multipleSelect: multiple,
		hoverClass: 'hover',
		focusClass: 'hover',
		progressUrl: $(el).data('progress'),
		responseType: 'json',
		accept: 'video/*',
		allowedExtensions: ['mp4','webm'],
		onChange: function( filename, extension, uploadBtn, fileSize, file ) {
			$('.alert', $target).remove();
		},
		onSubmit: function(filename, extension, uploadBtn, fileSize) {
			$target.prepend('<div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>');
			var wrapper = $('.progress', $target).get(0);
			this.setProgressContainer(wrapper);
			this.setProgressBar( $('.progress-bar', wrapper).get(0) );
			this.setPctBox( $('.progress-bar', wrapper).get(0) );
		},
		onExtError: function( filename, extension ) {
			$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Type de fichier non autorisé (mp4, webm)') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
		},
		onSizeError: function( filename, fileSize ) {
			$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Le fichier est trop volumineux') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
		},
		onComplete: function(filename, response) {
			if(!response) {
				$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
			}
			else {
				if(response.success) {
					var value = { filename: response.file, path: response.path, legende: {} };
					var value = {
						type: 'video',
						original_filename: filename,
						filename: response.file,
						path: response.path
					};
					var html = '<div class="_toParse image_thumb _toremove" data-type="video"><textarea class="_toParse_value" name="' + name_images + '">' + JSON.stringify(value) + '</textarea></div>';
					if( multiple )
						$target.append(html);
					else
						$target.html(html);
					$('._toParse', $target).each(function(i, el) {
						parseBlock(el);
					});
				}
				else {
					$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + response.file + '<br>' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
					return false;
				}
			}
		}
	});
}


$('._upload_video').each(function(i, el) {
	createVideoUploader(el);
});
$(document).on('lightbox:show', function(e) {
	$('._upload_video', e.target).each(function(i, el) {
		createVideoUploader(el);
	});
});



/*
 * upload docs
 */

function createDocUploader(el) {
	var multiple = $(el).is('[data-single]') ? false : true;
	var name_images = $(el).is('[data-name-images]') ? $(el).data('name-images') : 'documents';
	var $target = $(el).is('[data-target]') ? $($(el).data('target')) : $(el).next();
	var fixe = $(el).is('[data-fixe]');
	var history = $(el).is('[data-history]');
	var name_history = $(el).is('[data-history-name]') ? $(el).data('history-name') : name_images + '_history';
	var imageuploader = new ss.SimpleUpload({
		button: $(el),
		url: $(el).data('url'),
		name: 'uploadfile',
		multiple: multiple,
		multipleSelect: multiple,
		hoverClass: 'hover',
		focusClass: 'hover',
		progressUrl: $(el).data('progress'),
		responseType: 'json',
		allowedExtensions: ['gif', 'png', 'jpeg', 'jpg', 'mp4', 'webm', 'csv', 'doc', 'docx', 'epub', 'json', 'odp', 'ods', 'odt', 'pdf', 'ppt', 'pptx', 'rar', 'rtf', 'tar', 'xls', 'xlsx', 'zip', '7z'],
		onChange: function( filename, extension, uploadBtn, fileSize, file ) {
			$('.alert', $target).remove();
		},
		onSubmit: function(filename, extension, uploadBtn, fileSize) {
			$('.alert', $target).remove();
			$target.prepend('<div class="progress"><div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>');
			var wrapper = $('.progress', $target).get(0);
			this.setProgressContainer(wrapper);
			this.setProgressBar( $('.progress-bar', wrapper).get(0) );
			this.setPctBox( $('.progress-bar', wrapper).get(0) );
		},
		onExtError: function( filename, extension ) {
			$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Type de fichier non autorisé (csv, doc, docx, epub, json, odp, ods, odt, pdf, ppt, pptx, rar, rtf, tar, xls, xlsx, zip, 7z)') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
		},
		onSizeError: function( filename, fileSize ) {
			$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Le fichier est trop volumineux') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
		},
		onComplete: function(filename, response) {
			if(!response) {
				$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
			}
			else {
				if(response.success) {
					var value = {
						type: 'document',
						original_filename: filename,
						filename: response.file,
						path: response.path,
						label: response.label,
						datetime: response.datetime
					};
					var html = '<div class="_toParse image_thumb document_thumb' + ( fixe ? ' document-fixe_thumb' : '' ) + ' _toremove" data-type="document' + ( fixe ? '-fixe' : '' ) + '"><textarea class="_toParse_value" name="' + name_images + '">' + JSON.stringify(value) + '</textarea></div>';
					if( multiple )
						$target.append(html);
					else {
						if( history && $('.document_thumb', $target).get().length ) {
							var old_html = '<div class="_toParse image_thumb document_thumb' + ( fixe ? ' document-fixe_thumb' : '' ) + ' _toremove" data-type="document_history' + ( fixe ? '-fixe' : '' ) + '"><textarea class="_toParse_value" name="' + name_history + '">' + $('._toParse_value', $target).val() + '</textarea></div>';
							$($(el).data('history')).prepend(old_html);
							$('._toParse', $($(el).data('history'))).each(function(i, el) {
								parseBlock(el);
							});
						}
						$target.html(html);
					}
					$('._toParse', $target).each(function(i, el) {
						parseBlock(el);
					});
				}
				else {
					$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Une erreur est survenue lors de l\'upload du fichier') + response.file + '<br>' + response.msg + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
					return false;
				}
			}
		}
	});
}


$('._upload_doc').each(function(i, el) {
	createDocUploader(el);
});
$(document).on('lightbox:show', function(e) {
	$('._upload_doc', e.target).each(function(i, el) {
		createDocUploader(el);
	});
});



/*
 * insert video online
 */
$(document).on('click', '._upload_video_ext', function(e) {
	var el = this;
	var multiple = $(el).is('[data-single]') ? false : true;
	var name_images = $(el).is('[data-name-images]') ? $(el).data('name-images') : 'videos';
	var $target = $(el).is('[data-target]') ? $($(el).data('target')) : $(el).next();
	var $input = $('input', $(el).parents('.input-group').get(0));

	$('.alert', $target).remove();

	var url = $input.val();
	var res;
	if(res = url.match(/(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*)).*/i)) {
		var thumb_url = 'http://img.youtube.com/vi/' + res[3] + '/0.jpg';
	}
	else if(res = url.match(/dailymotion.com\/video\/(.*)\/?(.*)/)) {
		var thumb_url = 'http://www.dailymotion.com/thumbnail/video/' + res[1];
	}
	else if(res = url.match(/(?:vimeo(?:pro)?.com)\/(?:[^\d]+)?(\d+)(?:.*)/)) {
		var thumb_url;
		$.getJSON('http://vimeo.com/api/v2/video/' + res[1] + '.json?callback=?').done(function(data) {
			thumb_url = data[0].thumbnail_large;
		});
	}
	else {
		$target.prepend('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + __str('Source introuvable') + '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>');
				return false;
	}

	var value = {
		type: 'video_ext',
		url: url,
		thumbnail: thumb_url
	};
	var html = '<div class="_toParse image_thumb _toremove" data-type="video_ext"><textarea class="_toParse_value" name="' + name_images + '">' + JSON.stringify(value) + '</textarea></div>';
	if( multiple )
		$target.append(html);
	else
		$target.html(html);
	$('._toParse', $target).each(function(i, el) {
		parseBlock(el);
	});

	$input.val('');
});




/*
 * parse block
 */
function parseBlock(el) {
	var val;
	try {
		val = JSON.parse( $('._toParse_value:eq(0)', el).val() );
	}
	catch(e) {
		val = {};
	}

	var readonly = $(el).is('[data-readonly]');
	
	if( $(el).data('type') == 'image' ) {
		var template = '<div class="card">';
		if( !readonly )
			template += '<div class="card-header d-flex justify-content-between">' + 
				'<span class="sort_handle" title="' + __str('Déplacer') + '"><i class="material-icons">drag_indicator</i></span>' + 
				'<a target="_blank" href="{{image}}" title="' + __str('Télécharger') + '" {{download}}><i class="material-icons">get_app</i></a>' + 
				'<a class="_edit_image" href="#" title="' + __str('Modifier') + '"><i class="material-icons">edit</i></a>' + 
				'<a data-remove data-confirm class="text-danger" href="#" title="' + __str('Supprimer') + '"><i class="material-icons">clear</i></a>' + 
			'</div>';
			template += '<div class="image" style="background-image:url({{thumbnail}});">' + 
				'<a data-fancybox="{{gallery}}" href="{{image}}"><i class="material-icons">zoom_in</i></a>' + 
			'</div>' + 
		'</div>';

		var html = template.replace(/{{image}}/g, val.path + val.filename);
		html = html.replace(/{{thumbnail}}/g, val.thumbnail);
		html = html.replace(/{{gallery}}/g, $(el).is('[data-gallery]') ? $(el).data('gallery') : '');
		if( val.hasOwnProperty('original_filename') )
			html = html.replace(/{{download}}/g, 'download="' + sanitize(val.original_filename) + '"');
		else
			html = html.replace(/{{download}}/g, 'download');
		$(el).append(html).removeClass('_toParse');
	}

	else if( $(el).data('type') == 'video' ) {
		var template = '<div class="card">';
		if( !readonly )
			template += '<div class="card-header d-flex justify-content-between">' + 
				'<span class="sort_handle" title="' + __str('Déplacer') + '"><i class="material-icons">drag_indicator</i></span>' + 
				'<a target="_blank" href="{{image}}" title="' + __str('Télécharger') + '" {{download}}><i class="material-icons">get_app</i></a>' + 
				'<a data-remove data-confirm class="text-danger" href="#"  title="' + __str('Supprimer') + '"><i class="material-icons">clear</i></a>' + 
			'</div>';
			template += '<div class="image">' + 
				'<video>' +
					'<source src="{{video}}" type="video/{{extension}}">' +
				'</video>' +
				'<a data-fancybox href="{{video}}"><i class="material-icons">zoom_in</i></a>' + 
			'</div>' + 
		'</div>';
		var t = val.filename.split('.');
		var html = template.replace(/{{video}}/g, val.path + val.filename);
		html = html.replace(/{{extension}}/g, t[t.length - 1]);
		if( val.hasOwnProperty('original_filename') )
			html = html.replace(/{{download}}/g, 'download="' + sanitize(val.original_filename) + '"');
		else
			html = html.replace(/{{download}}/g, 'download');
		$(el).append(html).removeClass('_toParse');
	}

	else if( $(el).data('type') == 'video_ext' ) {
		var template = '<div class="card">';
		if( !readonly )
			template += '<div class="card-header d-flex justify-content-between">' + 
				'<span class="sort_handle" title="' + __str('Déplacer') + '"><i class="material-icons">drag_indicator</i></span>' + 
				'<a data-remove data-confirm class="text-danger" href="#" title="' + __str('Supprimer') + '"><i class="material-icons">clear</i></a>' + 
			'</div>';
			template += '<div class="image" style="background-image:url({{thumbnail}});">' + 
				'<a data-fancybox href="{{url}}"><i class="material-icons">zoom_in</i></a>' + 
			'</div>' + 
		'</div>';

		var html = template.replace(/{{url}}/g, val.url);
		html = html.replace(/{{thumbnail}}/g, val.thumbnail);
		$(el).append(html).removeClass('_toParse');
	}

	else if( $(el).data('type') == 'document' ) {
		var template = '<div class="card">' + 
			'<div class="card-header d-flex">';
			if( !readonly ) {
				template += '<span class="sort_handle" title="' + __str('Déplacer') + '"><i class="material-icons">drag_indicator</i></span>';
				template += '<a class="mx-3" target="_blank" href="{{path}}{{filename}}" title="' + __str('Télécharger') + '" {{download}}><i class="material-icons">get_app</i></a>';
				template += '<a class="_edit_document mr-2" href="#" title="' + __str('Modifier') + '"><i class="material-icons mr-3">edit</i><span class="label">{{label}}</span></a>' + 
				'<span class="d-flex align-items-center mr-2">{{extension}}</span>' + 
				'<a data-remove data-confirm class="ml-auto text-danger" href="#" title="' + __str('Supprimer') + '"><i class="material-icons">clear</i></a>';
			}
			else {
				template += '<a target="_blank" href="{{path}}{{filename}}" title="' + __str('Télécharger') + '" {{download}}><i class="material-icons mr-2">get_app</i><span class="label mr-2">{{label}}</span>' + 
				'<span class="d-flex align-items-center mr-2">{{extension}}</span></a>';
			}
			template += '</div>' + 
		'</div>';
		var html = template.replace(/{{path}}/g, val.path);
		html = html.replace(/{{filename}}/g, val.filename);
		html = html.replace(/{{label}}/g, val.label);
		html = html.replace(/{{extension}}/g, '<span class="badge badge-secondary text-uppercase">' + val.filename.split('.').pop() + '</span>');
		if( val.hasOwnProperty('original_filename') )
			html = html.replace(/{{download}}/g, 'download="' + sanitize(val.original_filename) + '"');
		else
			html = html.replace(/{{download}}/g, 'download="' + sanitize(val.label) + '"');
		$(el).append(html).removeClass('_toParse');
	}

	else if( $(el).data('type') == 'document-fixe' ) {
		var template = '<div class="card">' + 
			'<div class="card-header d-flex">';
				template += '<a class="mr-3" target="_blank" href="{{path}}{{filename}}" title="' + __str('Télécharger') + '" {{download}}><i class="material-icons">get_app</i></a>';
			if( !readonly )
				template += '<a class="_edit_document mr-2" href="#" title="' + __str('Modifier') + '"><i class="material-icons mr-3">edit</i><span class="label">{{label}}</span></a>' + 
				'<span class="d-inline mr-2">{{extension}}</span>' + 
				'<a data-remove data-confirm class="ml-auto text-danger" href="#" title="' + __str('Supprimer') + '"><i class="material-icons">clear</i></a>';
			else
				template += '<span class="label">{{label}}</span>' + 
				'<span class="d-inline mr-2">{{extension}}</span>'; 
			template += '</div>' + 
		'</div>';
		var html = template.replace(/{{path}}/g, val.path);
		html = html.replace(/{{filename}}/g, val.filename);
		html = html.replace(/{{label}}/g, val.label);
		html = html.replace(/{{extension}}/g, '<span class="badge badge-secondary p-1 text-uppercase">' + val.filename.split('.').pop() + '</span>');
		if( val.hasOwnProperty('original_filename') )
			html = html.replace(/{{download}}/g, 'download="' + sanitize(val.original_filename) + '"');
		else
			html = html.replace(/{{download}}/g, 'download');
		$(el).append(html).removeClass('_toParse');
	}

	else if( $(el).data('type') == 'document_history-fixe' ) {
		var template = '<div class="card">' + 
			'<div class="card-header d-flex">';
				template += '<a target="_blank" href="{{path}}{{filename}}" title="' + __str('Télécharger') + '" {{download}}><i class="material-icons">get_app</i></a>';

				template += '<span class="mx-3">' + __str('Version du') + ' {{datetime}} : </span>';
				template += '<span class="label">{{label}}</span>' + 
					'<span class="d-inline mx-2">{{extension}}</span>';
				if( !readonly )
					template += '<a data-remove data-confirm class="ml-auto text-danger" href="#" title="' + __str('Supprimer') + '"><i class="material-icons">clear</i></a>';
			template += '</div>' + 
		'</div>';
		var t = val.datetime.match(/(\d+)/g);
		var html = template.replace(/{{path}}/g, val.path);
		html = html.replace(/{{filename}}/g, val.filename);
		html = html.replace(/{{label}}/g, val.label);
		html = html.replace(/{{extension}}/g, '<span class="badge badge-secondary p-1 text-uppercase">' + val.filename.split('.').pop() + '</span>');
		html = html.replace(/{{datetime}}/g, t[2] + '/' + t[1] + '/' + t[0] + ' ' + t[3] + ':' + t[4] + ':' + t[5]);
		if( val.hasOwnProperty('original_filename') )
			html = html.replace(/{{download}}/g, 'download="' + sanitize(val.original_filename) + '"');
		else
			html = html.replace(/{{download}}/g, 'download');
		$(el).append(html).removeClass('_toParse');
	}


}


/*
 * edit image legend
 */
$(document).on('click', '._edit_image', function(e) {
	e.preventDefault();
	var $this = $(this);
	var $block = $($this.parents('.image_thumb').get(0));
	var value = JSON.parse( $('._toParse_value', $block).val() );

	var d = new Date();
	var tid = 'frm_' + d.getTime();

	var html = '<div class="modal fade" tabindex="-1" role="dialog">' + 
		'<div class="modal-dialog modal-dialog-centered" role="document">' + 
			'<div class="modal-content">' + 
				'<div class="modal-header">' + 
					'<h5 class="modal-title">' + __str('Modifier l\'image') + '</h5>' + 
					'<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + 
				'</div>' + 
				'<div class="modal-body">' + 
					'<img class="d-block mx-auto mb-4" style="max-height:200px;" src="' + value.thumbnail + '">';
					for(var i = 0; i < _LANGS.length; i++) {
						html += '<div class="form-group lang_toggle lang_' + _LANGS[i] + '" data-lang="' + _LANGS[i] + '">' + 
							'<label for="' + tid + '_' + _LANGS[i] + '">' + __str('Légende') + (_LANGS.length > 1 ? ' (' + _LANGS[i].toUpperCase() + ')' : '') + '</label>';
							if( _LANGS.length > 1 ) {
								html += '<div class="btn-group lang_selector">';
									for(var j = 0; j < _LANGS.length; j++) {
										html += '<button type="button" class="btn btn-sm btn-light" data-lang="' + _LANGS[j] + '"><img src="' + _DIR_IMG + 'lang/' + _LANGS[i] + '.png" alt="' + _LANGS[i] + '"></button>';
									}
								html += '</div>';
							}
							var v = value.legende.hasOwnProperty(_LANGS[i]) ? value.legende[_LANGS[i]] : '';
							html += '<input type="text" id="' + tid + '_' + _LANGS[i] + '" placeholder="' + __str('Légende') + '" class="form-control" value="' + v + '">' + 
						'</div>';
					}
				html += '</div>' + 
				'<div class="modal-footer">' + 
					'<button type="button" class="btn btn-secondary" data-dismiss="modal">' + __str('Annuler') + '</button>' + 
					'<button type="button" class="btn btn-success">' + __str('Enregistrer') + '</button>' + 
				'</div>' + 
			'</div>' + 
		'</div>' + 
	'</div>';

	var $modal = $(html);
	$modal.modal().on('click', '.btn-success', function() {
		value.legende = {};
		for(var i = 0; i < _LANGS.length; i++) {
			value.legende[_LANGS[i]] = $('#' + tid + '_' + _LANGS[i]).val();
		}
		$('._toParse_value', $block).val( JSON.stringify(value) );
		$modal.modal('hide');
	}).on('hidden.bs.modal', function() {
		$modal.modal('dispose').remove();
	});
});




/*
 * edit document label
 */
$(document).on('click', '._edit_document', function(e) {
	e.preventDefault();
	var $this = $(this);
	var $block = $($this.parents('.image_thumb').get(0));
	var value = JSON.parse( $('._toParse_value', $block).val() );

	var d = new Date();
	var tid = 'frm_' + d.getTime();

	var html = '<div class="modal fade" tabindex="-1" role="dialog">' + 
		'<div class="modal-dialog modal-dialog-centered" role="document">' + 
			'<div class="modal-content">' + 
				'<div class="modal-header">' + 
					'<h5 class="modal-title">' + __str('Modifier le document') + '</h5>' + 
					'<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' + 
				'</div>' + 
				'<div class="modal-body">' + 
					'<p class="text-center">' + 
						'<a class="btn btn-link" target="_blank" href="' + value.path + value.filename + '">' + 
							'<i class="material-icons">attach_file</i>' + 
							'<span>' + __str('Télécharger') + '</span>' + 
						'</a>' + 
					'</p>' + 
					'<div class="form-group">' + 
						'<label for="' + tid + '">' + __str('Nom') + '</label>' + 
						'<input type="text" id="' + tid + '" placeholder="' + __str('Nom') + '" class="form-control" value="' + value.label + '">' + 
					'</div>' + 
				'</div>' + 
				'<div class="modal-footer">' + 
					'<button type="button" class="btn btn-secondary" data-dismiss="modal">' + __str('Annuler') + '</button>' + 
					'<button type="button" class="btn btn-success">' + __str('Enregistrer') + '</button>' + 
				'</div>' + 
			'</div>' + 
		'</div>' + 
	'</div>';

	var $modal = $(html);
	$modal.modal().on('click', '.btn-success', function() {
		value.label = $('#' + tid).val();
		$('._toParse_value', $block).val( JSON.stringify(value) );
		$('.label', $block).html( value.label );
		$modal.modal('hide');
	}).on('hidden.bs.modal', function() {
		$modal.modal('dispose').remove();
	});
});






/*
 * sortable
 */
function _init_sortable() {

	$('._sortable_handle').sortable({
		handle: '.sort_handle',
		filter: '.ignore',
		onEnd: function (e) {
			var item = e.item;
			var parent = $(item).parents('._sortable_handle').get(0);
			// on refait les itérations
			if( $('> [data-iteration]', parent).get().length ) {
				$('[data-iteration]', parent).each(function(i, el) {
					var old = $(el).data('iteration');
					$(el).data('iteration', i);
					$(el).attr('data-iteration', i);
					$('[name*="[' + old + ']"]', el).each(function(j, input) {
						var name = $(input).attr('name');
						name = name.replace('[' + old + ']', '[' + i + ']');
						$(input).attr('name', name);
					});
				});
			}
		}
	});

}



$(function() {

	_init_sortable();

	$('._toParse').each(function(i, el) {
		parseBlock(el);
	});

});

$(document).on('lightbox:show', function(e) {

	$('._toParse', e.target).each(function(i, el) {
		parseBlock(el);
	});

});